import React from 'react';
import PropTypes from 'prop-types';

const UiDismissSmallPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8.884 8l2.828-2.828a.375.375 0 0 0 0-.53l-.353-.354a.375.375 0 0 0-.53 0L8 7.116 5.172 4.288a.375.375 0 0 0-.53 0l-.354.353a.375.375 0 0 0 0 .53L7.116 8l-2.828 2.828a.375.375 0 0 0 0 .53l.353.354a.375.375 0 0 0 .53 0L8 8.884l2.828 2.828a.375.375 0 0 0 .53 0l.354-.353a.375.375 0 0 0 0-.53L8.884 8z"
    />
  );
};

UiDismissSmallPath.propTypes = {
  fill: PropTypes.string,
};

export default UiDismissSmallPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-dismiss-small.jsx